export default "__VITE_ASSET__CtbD71Hi__"